import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import {
  labelColumnStyles,
  slotLabelContainerStyles,
  slotLabelItemStyles,
} from './styles';

export function InsulinPumpSettingsInputLabel(): React.JSX.Element {
  return (
    <Grid sx={labelColumnStyles} display="flex" >
      <Box sx={slotLabelContainerStyles}>
        <Box sx={slotLabelItemStyles}>Basal</Box>
        <Box sx={slotLabelItemStyles}>I/C</Box>
        <Box sx={slotLabelItemStyles}>ISF</Box>
      </Box>
    </Grid>
  );
}
